<template>
  <FuzzyQuotePreviewDrawer :visible.sync="visible" :title="title" />
</template>

<script>
import FuzzyQuotePreviewDrawer from './FuzzyQuotePreviewDrawer.vue'

const DEFAULT_TITLE = '模糊询价框架报价预览'
const FUZZY_QUOTE_PREVIEW_ACTION = 'quote.fuzzyPreview'

export default {
  name: 'FuzzyQuotePreviewDrawerHost',
  components: { FuzzyQuotePreviewDrawer },
  data() {
    return {
      visible: false,
      title: DEFAULT_TITLE
    }
  },
  mounted() {
    document.addEventListener('cosmo-claw-ui-action', this.handleUiAction)
  },
  beforeDestroy() {
    document.removeEventListener('cosmo-claw-ui-action', this.handleUiAction)
  },
  methods: {
    handleUiAction(e) {
      const { name, params = {}} = e.detail || {}
      if (name !== FUZZY_QUOTE_PREVIEW_ACTION) return
      // 接住动作，避免卡片侧回退提示
      e.preventDefault()
      const rfqNo = params.rfqNo || params.quoteNo
      this.title = rfqNo ? `${DEFAULT_TITLE} · ${rfqNo}` : DEFAULT_TITLE
      this.visible = true
    }
  }
}
</script>
